import { render, staticRenderFns } from "./voice.vue?vue&type=template&id=04a927c6&scoped=true"
import script from "./voice.vue?vue&type=script&lang=ts"
export * from "./voice.vue?vue&type=script&lang=ts"
import style0 from "./voice.vue?vue&type=style&index=0&id=04a927c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a927c6",
  null
  
)

export default component.exports